import { useNavigate } from 'react-router-dom';
import { RiArrowLeftSLine } from 'react-icons/ri';
import { FC, useState } from 'react';
import { Skeleton } from '@mui/material';
import { useDefaultColorValue } from 'services/queries/app';
import BreadCrumb from '../BreadCrumb';
import { useAppContext } from '../../../provider/AppProvider/AppProvider';

interface SubheadProps {
  enableBackButton?: boolean;
  backButtonHoverColor: string;
  backButtonColor: string;
  titleFontSize: string;
  title: string;
  activeBreadcrumbColor: string;
  breadcrumbColor: string;
  breadcrumbFontSize: string;
  isLoading?: boolean;
  buttonLink?: string;
}

const Subhead: FC<SubheadProps> = ({
  enableBackButton,
  backButtonHoverColor,
  backButtonColor,
  titleFontSize,
  title,
  activeBreadcrumbColor,
  breadcrumbColor,
  breadcrumbFontSize,
  isLoading,
  buttonLink,
}) => {
  const [isHovering, setIsHovering] = useState(false);
  const navigate = useNavigate();

  const handleMouseEnter = () => {
    setIsHovering(true);
  };

  const handleMouseLeave = () => {
    setIsHovering(false);
  };

  const colors = useDefaultColorValue();
  const {
    setup: {
      header: { menu },
      fonts,
    },
    config: { defaultLabels },
  } = useAppContext();

  const enabledModules = menu?.enabled_modules;

  const handleDisplayPageTitle = () => {
    let pageTitle = title;

    if (enabledModules?.includes(title)) {
      pageTitle = menu?.label_overrides[title]
        ? menu?.label_overrides[title]
        : defaultLabels[title as keyof typeof defaultLabels];
    }

    return pageTitle;
  };

  const handleClick = () => {
    if (buttonLink === '') {
      navigate(-1);
    } else {
      navigate(String(buttonLink));
    }
  };

  return (
    <div
      className={`flex flex-col justify-between items-start xl:items-center xl:flex-row
        ${enableBackButton === false ? 'my-3.5' : ''}`}
    >
      <div className="flex justify-start items-center pb-4 -mx-5">
        {enableBackButton === true ? (
          <button
            id="pageTitleBackButton"
            type="button"
            onClick={handleClick}
            style={{ color: colors.medium }}
          >
            <RiArrowLeftSLine
              size="64"
              style={{
                color: isHovering ? backButtonHoverColor : backButtonColor,
              }}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            />
          </button>
        ) : null}
        {isLoading === true ? (
          <div className="py-4 flex">
            <Skeleton height={24} width={75} />
            <div className="ml-4" />
            <Skeleton height={24} width={200} />
          </div>
        ) : (
          <h1
            className="text-3xl font-bold mb-0 pl-4"
            style={{ color: colors.dark, fontFamily: fonts.header }}
          >
            {handleDisplayPageTitle()}
          </h1>
        )}
      </div>

      <div className="hidden">
        {/* @TODO: Remove the hidden class once breadcrumbs is done */}
        <div className="w-full flex justify-end xl:w-auto xl:block xl:justify-start">
          <BreadCrumb
            activeBreadcrumbStyle={activeBreadcrumbColor}
            breadcrumbStyle={breadcrumbColor}
            fontSize={breadcrumbFontSize}
          />
        </div>
      </div>
    </div>
  );
};

export default Subhead;

Subhead.defaultProps = {
  isLoading: false,
  enableBackButton: true,
  buttonLink: '',
};
